import { toast } from "react-toastify";

export function errors_multiple(error) {
  const errorArray = error?.response?.data?.errors;
  Object.keys(errorArray).forEach((element, index) => {
    toast.error(`${element}: ${errorArray[element][0]}`);
  });
  return;
}


export function errors(error) {
  const errorArray = error?.response?.data?.errors;
  let errorMessage = "";

  if (errorArray) {

    
    if (errorArray) {
      Object.keys(errorArray).forEach((element, index) => {
        errorMessage += `${element}: ${errorArray[element][0]}\n`;
      });
  
      // Remove the trailing newline character
      errorMessage = errorMessage.trim();
  
      if (errorMessage) {
        toast.error(errorMessage, {
          autoClose: false,
          className: 'custom-toast-class',
          style: { whiteSpace: 'pre-line' },
        });
      }
    }

    // Object.keys(errorArray).forEach((element, index) => {
    //   errorMessage += `${element}: ${errorArray[element][0]}\n`;
    // });

    // // Remove the trailing newline character
    // errorMessage = errorMessage.trim();

    // if (errorMessage) {
    //   toast.error(errorMessage, { autoClose: false });
    // }
  }

  return;
}
